/**
 * 自增类型
 */
// eslint-disable-next-line no-unused-vars
import { OfficeNumberType } from '../../constants/character-type';
import {
    baseConversion,
    convertCircleNum,
    ROMAN_CAP,
    ROMAN_LOW_CASE,
    CAP,
    LOWCASE,
    CHINESE,
} from './base-convert';
const factory = {
    [OfficeNumberType.arabicPeriod](index) {
        return `${index}.\u00a0`;
    },
    [OfficeNumberType.arabicParenR](index) {
        return `${index})\u00a0`;
    },
    [OfficeNumberType.romanUcPeriod](index) {
        return `${
            baseConversion(
                ROMAN_CAP,
                index,
            )
        }.\u00a0`;
    },
    [OfficeNumberType.romanLcPeriod](index) {
        return `${
            baseConversion(
                ROMAN_LOW_CASE,
                index,
            )
        }.\u00a0`;
    },
    [OfficeNumberType.alphaUcPeriod](index) {
        return `${
            baseConversion(
                CAP,
                index,
            )
        }.\u00a0`;
    },
    [OfficeNumberType.alphaLcParenR](index) {
        return `${
            baseConversion(
                LOWCASE,
                index,
            )
        })\u00a0`;
    },
    [OfficeNumberType.alphaLcPeriod](index) {
        return `${
            baseConversion(
                LOWCASE,
                index,
            )
        }.\u00a0`;
    },
    [OfficeNumberType.ea1JpnChsDbPeriod](index) {
        return `${
            baseConversion(
                CHINESE,
                index,
            )
        }.\u00a0`;
    },
    [OfficeNumberType.arabicParenBoth](index) {
        return `(${index})\u00a0`;
    },
    [OfficeNumberType.circleNumDbPlain](index) {
        return convertCircleNum(index);
    },
    [OfficeNumberType.ea1ChsPeriod](index) {
        return `${
            baseConversion(
                CHINESE,
                index,
            )
        }.\u00a0`;
    },
    default(index) {
        return `${index}.`;
    },
};

function autoNumType(type) {
    return factory[type] || factory.default;
}

export const AUT_NUM_TRANSFORM_VERTICAL = 73;

export function getConvertAutoNumCharacterText(characterConfig, index = 0) {
    const { type, startAt = 1 } = characterConfig;
    return autoNumType(type)(index + startAt);
}

export const testObj = {
    factory,
};
